module.exports = __webpack_public_path__ + "img/2.d628e7d5.png";